import "./index.scss";
import React, { useState } from "react";
import { ReactComponent as InfoIcon } from "assets/info.svg";
import { useWindowDimensions } from "hooks/useWindowDimensions";

export const InfoHoverPopover = ({ children }) => {
  const { width } = useWindowDimensions();
  const [isOpen, setPopover] = useState(false);

  const isPrimaryDesktop = width < 1200;

  const togglePopover = () => {
    if (isPrimaryDesktop) setPopover(!isOpen);
  };

  return (
    <div
      className={`info-hover-popover ${isOpen ? "open" : "closed"}`}
      onClick={togglePopover}
      onMouseEnter={() => setPopover(true)}
      onMouseLeave={() => setPopover(false)}
    >
      <InfoIcon width="18" height="18" alt="info ico" className="info-button" />
      <div className="popover-content">{children}</div>
    </div>
  );
};
